export type Gardener = {
	id: string;
	name: string;
	role?: 'lead' | 'gardener' | 'specialist';
	capacity?: number; // hours per day (default: 8)
	skills?: string[]; // ['planting', 'hardscaping', 'irrigation', 'design', etc.]
	organizationId?: string; // which company they belong to
};

// Synthetic gardeners for demo
export const gardeners: Gardener[] = [
	{
		id: 'gard1',
		name: 'Maria Schmidt',
		role: 'lead',
		capacity: 8,
		skills: ['planting', 'design', 'project_management'],
		organizationId: 'org1'
	},
	{
		id: 'gard2',
		name: 'Thomas Weber',
		role: 'gardener',
		capacity: 8,
		skills: ['planting', 'hardscaping', 'irrigation'],
		organizationId: 'org1'
	},
	{
		id: 'gard3',
		name: 'Anna Müller',
		role: 'specialist',
		capacity: 6,
		skills: ['irrigation', 'design', 'sustainable_gardening'],
		organizationId: 'org1'
	},
	{
		id: 'gard4',
		name: 'Peter Fischer',
		role: 'gardener',
		capacity: 8,
		skills: ['hardscaping', 'planting'],
		organizationId: 'org1'
	},
	{
		id: 'gard5',
		name: 'Lisa Hoffmann',
		role: 'lead',
		capacity: 8,
		skills: ['design', 'planting', 'project_management'],
		organizationId: 'org2'
	},
	{
		id: 'gard6',
		name: 'Michael Bauer',
		role: 'gardener',
		capacity: 8,
		skills: ['hardscaping', 'irrigation'],
		organizationId: 'org2'
	},
	{
		id: 'gard7',
		name: 'Sophie Klein',
		role: 'gardener',
		capacity: 8,
		skills: ['planting', 'maintenance'],
		organizationId: 'org2'
	},
	{
		id: 'gard8',
		name: 'David Wagner',
		role: 'specialist',
		capacity: 6,
		skills: ['irrigation', 'hardscaping'],
		organizationId: 'org2'
	}
];

export function getGardenersByOrganization(organizationId: string): Gardener[] {
	return gardeners.filter(g => g.organizationId === organizationId);
}

export function getGardenerById(id: string): Gardener | undefined {
	return gardeners.find(g => g.id === id);
}

